// "Invalid Fields"
export const INVALID_VEHICLE_NO = 'InValid Vehicle number'
export const INVALID_MOBILE_NO = "Invalid Mobile Number"
export const INVALID_PINCODE = "Invalid Pincode"
export const INVALID_LICENCE_NO = "Enter Valid Licence Number"
export const INVALID_GST_NUMBER = 'Enter Valid GST Number';
export const INVALID_PAN_NUMBER = 'Enter Valid PAN Number';
export const INVALID_NAME = 'Enter Valid Name';
export const INVALID_EMAIL = 'Enter Valid Email';
export const FIELD_IS_REQUIRED = 'Field is required';
export const INVALID_BANK_ACCOUNT_NO = 'Invalid Bank Account Number';
export const INVALID_IFSC_CODE = 'Invalid IFSC Code';
export const INVALID_DELIVERY_DATE = "Delivery Date greater than Pickup Date."
export const INVALID_NUMBER = 'Invalid Number';
export const INVALID_LAND_LINE = 'Invalid Land line no';
export const INVALID_ADDRESS = 'Invalid Address';
export const INVALID_LATITUDE = 'Invalid latitude';
export const INVALID_LONGITUDE = 'Invalid longitude';
export const INVALID_FILE_TYPE = 'Please Select Valid File Type'
export const FILE_DELETED = 'File Deleted'
export const INVALID_EWAYBILL_NO = 'Invalid Eway Bill no. Please Enter 12 Digits'

export const INVALID_FIELDS = {
    INVALID_VEHICLE_NO: INVALID_VEHICLE_NO,
    INVALID_MOBILE_NO: INVALID_MOBILE_NO,
    INVALID_PINCODE: INVALID_PINCODE,
    INVALID_LICENCE_NO: INVALID_LICENCE_NO,
    INVALID_GST_NUMBER: INVALID_GST_NUMBER,
    INVALID_PAN_NUMBER: INVALID_PAN_NUMBER,
    INVALID_NAME: INVALID_NAME,
    INVALID_EMAIL: INVALID_EMAIL,
    INVALID_BANK_ACCOUNT_NO: INVALID_BANK_ACCOUNT_NO,
    INVALID_IFSC_CODE: INVALID_IFSC_CODE,
    INVALID_DELIVERY_DATE: INVALID_DELIVERY_DATE,
    INVALID_NUMBER: INVALID_NUMBER,
    INVALID_LAND_LINE: INVALID_LAND_LINE,
    INVALID_ADDRESS: INVALID_ADDRESS,
    INVALID_LATITUDE: INVALID_LATITUDE,
    INVALID_LONGITUDE: INVALID_LONGITUDE,
    INVALID_FILE_TYPE: INVALID_FILE_TYPE,
    INVALID_EWAYBILL_NO: INVALID_EWAYBILL_NO,
    INVALID_ADHAR_NUMBER: 'Invalid Adhar Number',
    MIN_LENGTH_IS_ONE: 'Min length is one',
    INVLAID_DATE : "Invalid Date",
    MAX_SIZE_15 : "Maximum size is 15",
    MAX_SIZE_50 : "Maximum size is 50",
    INVALID_MAXSIZE : 'Entered value size is greater than maximum allowed size',
    INVALID_MAXIMUMSIZE : (len)=> `Maximum size is ${len}`,
    END_DATE_SHOULD_BE_GREATER : "End date should be greater than start date.",
    MUST_BE_GREATER_THAN_ZERO : "Value must be greater than 0 .",
    INVALID_SPECIAL_CHARECTER : "Invalid Special Charecter",
    INVALID_RADIUS : "Value should be a integer or decimal number, less than or equal to 50 and maximum 5 digits after decimal point.",
    INVALID_FIELD : (field)=> `Invalid ${field}`

    // Note : Add new invalid fields here ...
}

// "Required Fields"
export const REQUIRED = 'Required';
export const VEHICLE_NO_REQUIRED = 'Vehicle Number is Required'
export const VEHICLE_TYPE_REQUIRED = 'Vehicle Type is Required'
export const OWNERSHIP_TYPE_REQUIRED = "Ownership Type is Required"
export const DRIVER_NAME_REQUIRED = 'Driver Name is Required'
export const DRIVER_NUMBER_REQUIRED = 'Driver Number is Required'
export const NETWORK_PROVIDER_REQUIRED = 'Network Provider is Required'
export const TRACKING_TYPE_REQUIRED = "Tracking Type is Required"
export const DATA_LOGGER_NO_MANDATORY = 'Data logger Number is mandatory'
export const BOOKING_BRANCH_REQUIRED = 'Booking Branch is Required'

export const ERROR_CREATING_BOOKING = 'Error While Creating Booking'
export const BOOKING_CREATION_SUCCESS = 'Booking Created Successfully'
export const BOOKING_UPDATE_SUCCESS = 'Booking Updated Successfully'

export const USER_NAME_REQUIRED = "Username Required"
export const PASSWORD_REQUIRED = "Password Required"

export const REQUIRED_FIELDS = {
    REQUIRED: REQUIRED,
    FIELD_IS_REQUIRED: FIELD_IS_REQUIRED,
    VEHICLE_NO_REQUIRED: VEHICLE_NO_REQUIRED,
    VEHICLE_TYPE_REQUIRED: VEHICLE_TYPE_REQUIRED,
    OWNERSHIP_TYPE_REQUIRED: OWNERSHIP_TYPE_REQUIRED,
    DRIVER_NAME_REQUIRED: DRIVER_NAME_REQUIRED,
    DRIVER_NUMBER_REQUIRED: DRIVER_NUMBER_REQUIRED,
    NETWORK_PROVIDER_REQUIRED: NETWORK_PROVIDER_REQUIRED,
    TRACKING_TYPE_REQUIRED: TRACKING_TYPE_REQUIRED,
    DATA_LOGGER_NO_MANDATORY: DATA_LOGGER_NO_MANDATORY,
    BOOKING_BRANCH_REQUIRED: BOOKING_BRANCH_REQUIRED,
    USER_NAME_REQUIRED: USER_NAME_REQUIRED,
    PASSWORD_REQUIRED: PASSWORD_REQUIRED,
    DELIVERY_DATE_GREATER_THAN_PICKUP : "Delivery Date greater than Pickup Date.",
    GST_NO_REQUIRED : "GST No is required",
    END_DATE_LESSER_THAN_START : "End date should be greater than the start date.",
    GST_EXEMPTED_REQUIRED : "Exempted reason is required",
    BRANCH_CODE : "Branch code is required",
    BRANCH_NAME : "Branch name is required",
   

    // Note : Add new required fields here ...
}

//login page
export const LOGIN_ERROR_MESSAGE = "Username or Password is wrong."
export const LOGIN_USERNAME_PLACEHOLDER = 'Username'
export const LOGIN_PASSWORD_PLACEHOLDER = 'Password'

//Messages 
export const NO_RECORDS_FOUND = "No Record(s) Found"
export const DELIVERY_UPDATE_SUCCESS_MESSAGE = "Delivery is updated."
export const IMPORT_FAILED = "Failed to import given data."

export const SUCCESS_MESSAGES = {
    DELIVERY_UPDATE_SUCCESS_MESSAGE: DELIVERY_UPDATE_SUCCESS_MESSAGE,
    BOOKING_CREATION_SUCCESS: BOOKING_CREATION_SUCCESS,
    BOOKING_UPDATE_SUCCESS: BOOKING_UPDATE_SUCCESS,
    FILE_UPLOAD_SUCCESS: "File Uploaded Successfully"

    // Note : Add new success messages here ...
}
export const ERROR_MESSAGES = {
    ERROR_CREATING_BOOKING: ERROR_CREATING_BOOKING,
    ERROR_IN_ROW: "Error in Row",
    ERROR_IN_COLUMN: "Error in Column",
    IMPORT_FAILED: "Failed to import given data.",
    MAX_LENGTH: (length) => `Max length is ${length}`,
    MIN_VALUE : (value) => `Value should be greater than ${Number(value)-1}`,
    CONSIGNEE_NOT_BILLINGPARTY : `The selected consignee is not a billing party , please add the billing party and continue.`,
    CONSIGNEE_NOT_BILLINGPARTY_ON_SUBMIT : `Couldnt update the delivery as the selected consignee is not a billing party , please add the billing party and continue.`
    // Note : Add new error messages here ...
}
export const PROMPTS = {
    NO_RECORDS_FOUND,
    LOADING: 'Loading...',
    CONFIRM_DELETE: 'Are you sure you want to delete?',
    DOCUMENTS_ABOUT_TO_EXPIRE : "Note : You are about to proceed with expired documents.",
    TRY_AGAIN : "Try Again",
    SOLVE_CAPTCHA : "Solve this captcha to continue",
    VALIDITY_ENDDATE_SHOULD_GREATER : "Validity end date should be greater than the start date.",
    CANT_CHANGE_IN_CURRENT_FINANCIAL_YEAR : (field)=> `${field} can only be changed after the validity end date expired.`
}

